export const AppointmentStatus = {
  Pending: 1,
  Cancelled: 2,
  Confirmed: 3,
  Completed: 4,
  NoShow: 5,
  AwaitingPayment: 6,
};

export const getAppointmentStatusKey = (status) => {
  if (typeof status === 'number') {
    if (status === AppointmentStatus.Pending) return 'pending';
    if (status === AppointmentStatus.Cancelled) return 'cancelled';
    if (status === AppointmentStatus.Confirmed) return 'confirmed';
    if (status === AppointmentStatus.Completed) return 'completed';
    if (status === AppointmentStatus.NoShow) return 'noShow';
    if (status === AppointmentStatus.AwaitingPayment) return 'awaitingPayment';
  }

  const normalized = String(status || '').toLowerCase().replace(/[\s_-]/g, '');
  if (normalized === 'pending') return 'pending';
  if (normalized === 'cancelled' || normalized === 'canceled') return 'cancelled';
  if (normalized === 'confirmed' || normalized === 'attended') return 'confirmed';
  if (normalized === 'completed') return 'completed';
  if (normalized === 'noshow') return 'noShow';
  if (normalized === 'awaitingpayment') return 'awaitingPayment';
  return 'unknown';
};

export const isInactiveAppointmentStatus = (status) => {
  const key = getAppointmentStatusKey(status);
  return key === 'cancelled' || key === 'noShow';
};

// The API serializes enums as strings, but older payloads and some management reads still
// carry the numeric form, so both have to be accepted.
export const getPaymentStatusKey = (paymentStatus) => {
  if (paymentStatus === 2 || paymentStatus === 'Paid') return 'paid';
  if (paymentStatus === 1 || paymentStatus === 'PendingPayment' || paymentStatus === 'Pending') return 'pendingPayment';
  if (paymentStatus === 4 || paymentStatus === 'Refunded') return 'refunded';
  if (paymentStatus === 6 || paymentStatus === 'PartiallyRefunded') return 'partiallyRefunded';
  if (paymentStatus === 7 || paymentStatus === 'Disputed') return 'disputed';
  // Only part was paid online; the balance is still owed in store.
  if (paymentStatus === 8 || paymentStatus === 'DepositPaid') return 'depositPaid';
  return 'unpaid';
};

export const isRefundedAppointment = (paymentStatus) => {
  const key = getPaymentStatusKey(paymentStatus);
  return key === 'refunded' || key === 'partiallyRefunded';
};

export const isPaidAppointment = (paymentStatus) => getPaymentStatusKey(paymentStatus) === 'paid';

export const isAwaitingOnRequestConfirmation = (appointment) => Boolean(appointment?.awaitingConfirmation);

export const getPendingOnRequestCandidateIds = (appointment) => {
  const fromPayload = appointment?.pendingCandidateTeamMemberIds;
  if (Array.isArray(fromPayload) && fromPayload.length > 0) {
    return [...new Set(fromPayload.map((id) => String(id)).filter(Boolean))];
  }

  const services = appointment?.services || [];
  return [...new Set(services.map((service) => service?.teamMemberId).filter(Boolean).map(String))];
};

export const resolveOnRequestActingTeamMemberId = (appointment, ownTeamMemberId) => {
  const candidates = getPendingOnRequestCandidateIds(appointment);
  const ownId = ownTeamMemberId ? String(ownTeamMemberId) : '';
  if (ownId && candidates.some((id) => id.toLowerCase() === ownId.toLowerCase())) {
    return ownId;
  }
  if (candidates.length === 1) {
    return candidates[0];
  }
  return '';
};
